/**
 * Error message. role="alert" so screen readers announce it the moment it
 * appears — an error nobody is told about is not an error message
 * (Decision #18).
 */
export function ErrorBanner({ error, id }) {
  if (!error) return null;
  const message = typeof error === 'string' ? error : (error.message ?? 'Something went wrong.');

  return (
    <p className="banner banner--error" role="alert" id={id}>
      {/* Never colour alone: the icon and the word carry the meaning too. */}
      <span aria-hidden="true">⚠</span> <strong>Error:</strong> {message}
    </p>
  );
}

export function SuccessBanner({ children }) {
  if (!children) return null;
  return (
    <p className="banner banner--success" role="status">
      <span aria-hidden="true">✓</span> {children}
    </p>
  );
}

export default ErrorBanner;
